import { DELETE_USER } from "./types";
import UsersApi from "../api/UsersApi";

export const deleteUser = user => async dispatch => {
  try {
    const { data } = await UsersApi().deleteUser(user);

    dispatch({
      type: DELETE_USER,
      payload: data,
    });
  } catch (error) {
    if (error.response?.status === 403) {
      console.error("No tienes permisos para eliminar este usuario");
    } else {
      console.error("Error al eliminar el usuario", error);
    }
    throw error;
  }
};
